export type ApiErrorKind =
  'network' | 'timeout' | 'authentication' | 'http' | 'cancelled' | 'response';

export abstract class ApiError extends Error {
  abstract readonly kind: ApiErrorKind;

  constructor(message?: string, cause?: unknown) {
    super(message, { cause });
    this.name = new.target.name;
  }
}

export class NetworkError extends ApiError {
  readonly kind = 'network';
}

export class TimeoutError extends ApiError {
  readonly kind = 'timeout';
}

export class AuthenticationError extends ApiError {
  readonly kind = 'authentication';
}

export class RequestCancelledError extends ApiError {
  readonly kind = 'cancelled';
}

export class ResponseParseError extends ApiError {
  readonly kind = 'response';
}

export class HttpError extends ApiError {
  readonly kind = 'http';

  constructor(
    readonly status: number,
    statusText?: string,
  ) {
    super(statusText && statusText.length > 0 ? statusText : `HTTP ${status}`);
  }
}
